import React, { useEffect, useRef } from "react";
import "./relatoriocaracterizacaoMiudoPrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

const peneirasPadrao = ["9,5", "6,3", "4,8", "2,36", "1,18", "0,60", "0,30", "0,15", "Fundo"];

const faixas = [
  ["0", "0", "0", "0"],
  ["0", "0", "0", "7"],
  ["0", "0", "5", "10"],
  ["0", "10", "20", "25"],
  ["5", "20", "30", "50"],
  ["15", "35", "55", "70"],
  ["50", "65", "85", "95"],
  ["85", "90", "95", "100"],
  ["100", "100", "100", "100"],
];

const limitesInferiores = [0, 0, 5, 10, 20, 35, 65, 90, 100];
const limitesSuperiores = [0, 7, 10, 25, 50, 70, 95, 100, 100];
const zonaUtilizavelInferior = faixas.map((linha) => Number(linha[0]));
const zonaOtimaInferior = faixas.map((linha) => Number(linha[1]));
const zonaOtimaSuperior = faixas.map((linha) => Number(linha[2]));
const zonaUtilizavelSuperior = faixas.map((linha) => Number(linha[3]));

function extrairLimitesFaixa(valor) {
  const numeros = String(valor || "").match(/\d+(?:[,.]\d+)?/g);
  if (!numeros || numeros.length < 2) return null;

  return {
    min: Number(numeros[0].replace(",", ".")),
    max: Number(numeros[1].replace(",", ".")),
  };
}

function temValorNumerico(valor) {
  if (valor === "" || valor === null || valor === undefined) return false;
  return Number.isFinite(Number(String(valor).replace(",", ".")));
}

const chartArea = {
  left: 56,
  right: 628,
  top: 18,
  bottom: 112,
};

function numeroPeneira(peneira) {
  if (peneira === "Fundo") return null;
  const valor = Number(String(peneira).replace(",", "."));
  return Number.isFinite(valor) && valor > 0 ? valor : null;
}

const aberturasLog = peneirasPadrao
  .map(numeroPeneira)
  .filter((valor) => valor !== null);
const aberturaMinimaLog = Math.log10(Math.min(...aberturasLog));
const aberturaMaximaLog = Math.log10(Math.max(...aberturasLog));

function xLogPeneira(index) {
  const abertura = numeroPeneira(peneirasPadrao[index]);
  if (abertura === null) return chartArea.left;

  const proporcao =
    (Math.log10(abertura) - aberturaMinimaLog) / (aberturaMaximaLog - aberturaMinimaLog);

  return chartArea.left + proporcao * (chartArea.right - chartArea.left);
}

function pontoGrafico(index, valor) {
  const x = xLogPeneira(index);
  const y = chartArea.top + Math.max(0, Math.min(100, valor)) * ((chartArea.bottom - chartArea.top) / 100);
  return `${x},${y}`;
}

function montarPontosFaixaPorIndice(indice, limite) {
  if (indice < 0) return "";

  return faixas
    .map((linhaFaixa, index) => {
      if (peneirasPadrao[index] === "Fundo") return null;
      const faixaSelecionada = extrairLimitesFaixa(linhaFaixa[indice]);
      if (!faixaSelecionada) return null;
      return pontoGrafico(index, faixaSelecionada[limite]);
    })
    .filter(Boolean)
    .join(" ");
}

function formatarDataBR(dataISO) {
  if (!dataISO) return "";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return null;
  return Number(String(valor).replace(",", "."));
}

function imprimir() {
  instalarEstiloPrintCaracterizacao();
  window.print();
}

function instalarEstiloPrintCaracterizacao() {
  const styleId = "print-style-caracterizacao";
  let style = document.getElementById(styleId);

  if (!style) {
    style = document.createElement("style");
    style.id = styleId;
    style.media = "print";
    style.textContent = "@page { size: A4 portrait; margin: 0; }";
    document.head.appendChild(style);
  }

  const limpar = () => {
    const styleAtual = document.getElementById(styleId);
    if (styleAtual) {
      styleAtual.remove();
    }
    window.removeEventListener("afterprint", limpar);
  };

  window.addEventListener("afterprint", limpar);
}

function montarLinhasGranulometria(caracterizacao) {
  const linhas = Array.isArray(caracterizacao?.granulometria)
    ? caracterizacao.granulometria
    : [];

  return peneirasPadrao.map((peneira, index) => ({
    peneira,
    massaA: linhas[index]?.massaA || "",
    massaB: linhas[index]?.massaB || "",
    retidaA: linhas[index]?.retidaA || "",
    retidaB: linhas[index]?.retidaB || "",
    variacao: linhas[index]?.variacao || "",
    media: linhas[index]?.media || "",
    acumulada: linhas[index]?.acumulada || "",
  }));
}

function valorOuTraco(valor) {
  return valor === "" || valor === null || valor === undefined ? "-" : valor;
}

function montarPontosLimite(valores) {
  return valores
    .map((valor, index) => pontoGrafico(index, valor))
    .join(" ");
}

export function ChartGranulometria({ linhas, tipoAgregado }) {
  const pontos = linhas
    .map((linha, index) => {
      const yValor = numero(linha.acumulada);
      if (peneirasPadrao[index] === "Fundo" || !temValorNumerico(linha.acumulada)) return null;
      return pontoGrafico(index, yValor);
    })
    .filter(Boolean)
    .join(" ");
  const pontosUtilizavelInferior = montarPontosLimite(zonaUtilizavelInferior);
  const pontosUtilizavelSuperior = montarPontosLimite(zonaUtilizavelSuperior);
  const pontosOtimaInferior = montarPontosLimite(zonaOtimaInferior);
  const pontosOtimaSuperior = montarPontosLimite(zonaOtimaSuperior);

  return (
    <div className="chart-box">
      <div className="chart-title">Análise Granulométrica - Agregado {tipoAgregado}</div>
      <svg className="chart-svg" viewBox="0 0 650 165" role="img" aria-label="Grafico granulometrico">
        {[0, 20, 40, 60, 80, 100].map((valor) => {
          const y = chartArea.top + valor * ((chartArea.bottom - chartArea.top) / 100);
          return (
            <React.Fragment key={`y-${valor}`}>
              <line x1={chartArea.left} x2={chartArea.right} y1={y} y2={y} stroke="#999" strokeWidth="0.7" />
              <text x={chartArea.left - 10} y={y + 3} fontSize="9" textAnchor="end">{valor}</text>
            </React.Fragment>
          );
        })}
        {peneirasPadrao.slice(0, -1).map((peneira, index) => (
          <React.Fragment key={`x-${peneira}`}>
            <line x1={xLogPeneira(index)} x2={xLogPeneira(index)} y1={chartArea.top} y2={chartArea.bottom} stroke="#999" strokeDasharray="3 3" strokeWidth="0.7" />
            <text x={xLogPeneira(index)} y={chartArea.bottom + 17} fontSize="7" textAnchor="middle">{peneira}</text>
          </React.Fragment>
        ))}
        <polyline points={pontosUtilizavelInferior} fill="none" stroke="#4f8fe8" strokeWidth="1.2" />
        <polyline points={pontosUtilizavelSuperior} fill="none" stroke="#4f8fe8" strokeWidth="1.2" />
        <polyline points={pontosOtimaInferior} fill="none" stroke="#111" strokeDasharray="4 2" strokeWidth="1.2" />
        <polyline points={pontosOtimaSuperior} fill="none" stroke="#111" strokeDasharray="4 2" strokeWidth="1.2" />
        {pontos && <polyline points={pontos} fill="none" stroke="#f00" strokeDasharray="5 3" strokeWidth="1.6" />}
        <text x="330" y="140" fontSize="10" fontWeight="700" fill="#003060" textAnchor="middle">Abertura das peneiras</text>
        <line x1="318" x2="350" y1="154" y2="154" stroke="#f00" strokeDasharray="5 3" strokeWidth="1.6" />
        <text x="354" y="157" fontSize="10">Amostra ensaiada</text>
        <line x1="480" x2="510" y1="154" y2="154" stroke="#4f8fe8" strokeWidth="1.2" />
        <text x="514" y="157" fontSize="10">Zona utilizável</text>
        <line x1="585" x2="615" y1="154" y2="154" stroke="#111" strokeDasharray="4 2" strokeWidth="1.2" />
        <text x="619" y="157" fontSize="10">Zona ótima</text>
        <text x="18" y="65" fontSize="10" fill="#003060" transform="rotate(-90 18 65)" textAnchor="middle">Porcentagem Retida Acumulada (%)</text>
      </svg>
    </div>
  );
}

export default function RelatorioCaracterizacaoPrint({ caracterizacao, autoPrint = false, onVoltar }) {
  useEffect(() => {
    const tituloAnterior = document.title;
    document.title = String(caracterizacao?.codigo || tituloAnterior);
    return () => { document.title = tituloAnterior; };
  }, [caracterizacao?.codigo]);

  const jaImprimiuRef = useRef(false);
  const linhas = montarLinhasGranulometria(caracterizacao);
  const codigoRelatorio =
    caracterizacao?.codigoFornecedor ||
    caracterizacao?.fornecedorCodigo ||
    caracterizacao?.codigoMaterial ||
    caracterizacao?.codigo ||
    "";
  useEffect(() => {
    instalarEstiloPrintCaracterizacao();

    return () => {
      const styleAtual = document.getElementById("print-style-caracterizacao");
      if (styleAtual) {
        styleAtual.remove();
      }
    };
  }, []);

  useEffect(() => {
    if (!autoPrint || jaImprimiuRef.current) return;
    jaImprimiuRef.current = true;
    const frame = window.requestAnimationFrame(imprimir);
    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint]);

  if (!caracterizacao) return null;

  return (
    <div className="relatorio-caracterizacao-print">
      {onVoltar && (
        <div className="acoes-print">
          <button className="btn-voltar" onClick={onVoltar}>Voltar</button>
          <button className="btn-imprimir" onClick={imprimir}>Imprimir</button>
        </div>
      )}

      <div className="pagina">
        <table className="cabecalho">
          <tbody>
            <tr>
              <td rowSpan="3" className="logo-cell"><LogoRelatorio alt="Logo" className="logo"  /></td>
              <td className="titulo-sistema">SISTEMA DE GESTÃO DA QUALIDADE</td>
              <td className="codigo-cell">RQ 2.2.3-B</td>
            </tr>
            <tr>
              <td rowSpan="2" className="titulo-documento">CARACTERIZAÇÃO DE AGREGADO MIÚDO</td>
              <td>Revisão 00</td>
            </tr>
            <tr>
              <td>20/08/2025</td>
            </tr>
          </tbody>
        </table>

        <table className="dados">
          <colgroup>
            <col style={{ width: "28mm" }} />
            <col />
            <col style={{ width: "24mm" }} />
          </colgroup>
          <tbody>
            <tr>
              <td className="label">Amostra:</td>
              <td className="valor">{caracterizacao.amostra || ""}</td>
              <td className="codigo">Cod. Material</td>
            </tr>
            <tr>
              <td className="label">Local da coleta:</td>
              <td className="valor">{caracterizacao.localColeta || ""}</td>
              <td className="codigo">{codigoRelatorio}</td>
            </tr>
            <tr>
              <td className="label">Procedência:</td>
              <td className="valor" colSpan="2">{caracterizacao.procedencia || ""}</td>
            </tr>
            <tr>
              <td colSpan="3" className="faixa">ENSAIOS</td>
            </tr>
          </tbody>
        </table>

        <table className="linha-meta">
          <tbody>
            <tr>
              <td style={{ width: "92px" }}>DATA:</td>
              <td className="valor" style={{ width: "112px" }}>{formatarDataBR(caracterizacao.dataGranulometria)}</td>
              <td className="valor">  COMPOSIÇÃO GRANULOMÉTRICA - NBR 7211</td>
              <td style={{ width: "90px" }}>OPERADOR:</td>
              <td className="valor" style={{ width: "132px" }}>{caracterizacao.operadorGranulometria || ""}</td>
            </tr>
          </tbody>
        </table>

        <table className="granulometria">
          <colgroup>
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "7%" }} />
            <col style={{ width: "8%" }} />
            <col style={{ width: "8.6%" }} />
            <col style={{ width: "8.6%" }} />
            <col style={{ width: "8.6%" }} />
            <col style={{ width: "8.6%" }} />
          </colgroup>
          <thead>
            <tr>
              <th colSpan="4">a) Massa inicial seca (g) {caracterizacao.massaInicialA || ""}</th>
              <th colSpan="4">b) Massa inicial seca (g) = {caracterizacao.massaInicialB || ""}</th>
              <th colSpan="4">Faixa em relação as % retidas<br /><strong>NBR 7211</strong></th>
            </tr>
            <tr>
              <th rowSpan="2">Abertura da<br />malha das<br />peneiras</th>
              <th colSpan="2">Massa retida (g)</th>
              <th colSpan="2">Massa retida (%)</th>
              <th rowSpan="2">Massa retida<br />variação<br />+- 4 %</th>
              <th rowSpan="2">Massa retida<br />média<br />(%)</th>
              <th rowSpan="2">Massa retida<br />acumulada<br />(%)</th>
              <th colSpan="2">Limites Inferiores</th>
              <th colSpan="2">Limites Superiores</th>
            </tr>
            <tr>
              <th>Ensaio a</th>
              <th>Ensaio b</th>
              <th>Ensaio a</th>
              <th>Ensaio b</th>
              <th>Zona<br />utilizável</th>
              <th>Zona<br />ótima</th>
              <th>Zona<br />ótima</th>
              <th>Zona<br />utilizável</th>
            </tr>
          </thead>
          <tbody>
            {linhas.map((linha, index) => (
              <tr key={linha.peneira}>
                <td className={index >= 6 && index <= 15 ? "peneira-vermelha" : ""}>{linha.peneira}</td>
                <td>{valorOuTraco(linha.massaA)}</td>
                <td>{valorOuTraco(linha.massaB)}</td>
                <td>{valorOuTraco(linha.retidaA)}</td>
                <td>{valorOuTraco(linha.retidaB)}</td>
                <td>{valorOuTraco(linha.variacao)}</td>
                <td>{valorOuTraco(linha.media)}</td>
                <td className="azul">{valorOuTraco(linha.acumulada)}</td>
                {faixas[index].map((faixa, faixaIndex) => <td key={faixaIndex}>{faixa}</td>)}
              </tr>
            ))}
            <tr className="total">
              <td>Total</td>
              <td>{caracterizacao.totalMassaA || ""}</td>
              <td>{caracterizacao.totalMassaB || ""}</td>
              <td>O max.</td>
              <td>
  {caracterizacao.moduloFinura
    ? caracterizacao.diferencaMaxima
    : ""}
</td>
              <td colSpan="2">Módulo de finura</td>
              <td className="peneira-vermelha">{caracterizacao.moduloFinura || ""}</td>
              <td colSpan="4">{caracterizacao.tolerancias || "1,55  2,20  2,90  3,50"}</td>
            </tr>
          </tbody>
        </table>

        <ChartGranulometria
          linhas={linhas}
          tipoAgregado="Miúdo"
        />

        <TabelaDensidade caracterizacao={caracterizacao} />
        <TabelaMassaUnitaria caracterizacao={caracterizacao} />

        <div className="observacoes">
          <strong>OBSERVAÇÕES:</strong> {caracterizacao.observacoes || ""}
        </div>
        <table className="rodape">
          <tbody>
            <tr>
              <td>RESPONSÁVEL:</td>
              <td style={{ width: "132px" }}>DATA:</td>
            </tr>
          </tbody>
        </table>
        <div className="rodape-restrito">
          <div className="linha-rodape" />
          <div>DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA</div>
        </div>
      </div>
    </div>
  );
}

function TabelaDensidade({ caracterizacao }) {
  const d = caracterizacao.densidade || {};
  const media = d.densidadeMedia || "";

  return (
    <table className="ensaio-secundario">
      <tbody>
        <tr>
          <td className="data-label meta-combinada" colSpan="2">
            D a t a. <span>{formatarDataBR(caracterizacao.dataDensidade)}</span>
          </td>
          <td className="titulo" colSpan="2">DENSIDADE E ABSORÇÃO NBR 16917</td>
          <td className="operador-label meta-combinada" colSpan="2">
            OPERADOR: <span>{caracterizacao.operadorDensidade || ""}</span>
          </td>
        </tr>
        {[
          ["A", "Material (sss)", "-", d.materialSss1, d.materialSss2],
          ["B", "Frasco+ Material (sss) + ag", "-", d.frascoMaterial1, d.frascoMaterial2],
          ["C", "Frasco+ agua", "-", d.frascoAgua1, d.frascoAgua2],
          ["D", "Peso do material imerso", "D = B - C", d.pesoImerso1, d.pesoImerso2],
          ["E", "Massa de água deslocada (g)", "E = A - D", d.volumeSss1, d.volumeSss2],
          ["F", "Massa de água equivalente ao volume real (g)", "F = G - D", d.volumeSeco1, d.volumeSeco2],
          ["G", "Material seco estufa", "-", d.materialSeco1, d.materialSeco2],
          ["H", "Densidade relativa do agregado (sss)", "H = A / E", d.densidadeSss1, d.densidadeSss2],
          ["I", "Densidade relativa do agregado (seco)", "I = G / E", d.densidadeSeco1, d.densidadeSeco2],
          ["J", "Densidade relativa média (sss)", "J = (H1 + H2) / 2", media, "", true],
          ["Ab)", "Absorção do agregado (%)", "[(A - G) / G] * 100", d.absorcao1, d.absorcao2],
        ].map((linha, index) => (
          <tr key={index}>
            <td>{linha[0]}</td>
            <td style={{ textAlign: "left" }}>{linha[1]}</td>
            <td>{linha[2]}</td>
            {linha[5] ? (
              <td colSpan="3">{linha[3]}</td>
            ) : (
              <>
                <td>{linha[3]}</td>
                <td colSpan="2">{linha[4]}</td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function TabelaMassaUnitaria({ caracterizacao }) {
  const m = caracterizacao.massaUnitaria || {};
  const media = m.mediaMassaUnitaria || "";

  return (
    <table className="ensaio-secundario">
      <tbody>
        <tr>
          <td className="data-label meta-combinada" colSpan="2">
            D a t a: <span>{formatarDataBR(caracterizacao.dataMassaUnitaria)}</span>
          </td>
          <td className="titulo" colSpan="2">MASSA UNITÁRIA EM ESTADO SOLTO NBR 16972</td>
          <td className="operador-label meta-combinada" colSpan="2">
            OPERADOR: <span>{caracterizacao.operadorMassaUnitaria || ""}</span>
          </td>
        </tr>
        {[
          ["-", "Determinações", "-", "1", "2"],
          ["A", "Volume do recipiente", "-", m.volume1, m.volume2],
          ["B", "Massa do recipiente vazio", "-", m.recipienteVazio1, m.recipienteVazio2],
          ["C", "Massa do recipiente + agregado", "-", m.recipienteAgregado1, m.recipienteAgregado2],
          ["D", "Massa do agregado", "D = C - B", m.massaAgregado1, m.massaAgregado2],
          ["E", "M. unitária solta do agregado", "E = D / A", m.massaUnitaria1, m.massaUnitaria2],
          ["F", "Média da massa unitária solta", "F = (E1 + E2) / 2", media, "", true],
        ].map((linha, index) => (
          <tr key={index}>
            <td>{linha[0]}</td>
            <td style={{ textAlign: "left" }}>{linha[1]}</td>
            <td>{linha[2]}</td>
            {linha[5] ? (
              <td colSpan="3">{linha[3]}</td>
            ) : (
              <>
                <td>{linha[3]}</td>
                <td colSpan="2">{linha[4]}</td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
